var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.926,
    height: 20.818,
    viewBox: "0 0 18.926 20.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-login",
    transform: "translate(-18.75 84.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M54.071-63.557a.946.946,0,0,1-.946-.946.946.946,0,0,1,.946-.946H58.8a.946.946,0,0,0,.946-.946V-81.536a.946.946,0,0,0-.946-.946H54.071a.946.946,0,0,1-.946-.946.946.946,0,0,1,.946-.946H58.8a2.84,2.84,0,0,1,2.839,2.839V-66.4A2.84,2.84,0,0,1,58.8-63.557Z",
    transform: "translate(-23.966)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M47.144-60.894l-3.117-3.116a.948.948,0,0,1,0-1.339.948.948,0,0,1,1.339,0l3.785,3.785a.948.948,0,0,1,0,1.339l-3.785,3.785a.948.948,0,0,1-1.339,0,.948.948,0,0,1,0-1.339Z",
    transform: "translate(-17.43 -13.072)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M31.052-53.125a.946.946,0,0,1,.946.946.946.946,0,0,1-.946.946H19.7a.946.946,0,0,1-.946-.946.946.946,0,0,1,.946-.946Z",
    transform: "translate(0 -21.787)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon-login.51bb60d8.svg";
export { ForwardRef as ReactComponent };